import { Grid } from "@mui/material";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { TextField } from "@material-ui/core";

function SearchBar({
  width,
  placeHolder,
  onChagevalue,
  backgroundColor,
  borderRadius,
  height,
}) {
  return (
    <Grid
      sx={{
        width: width ? width : 0,
        height: height ? height : 40,
        backgroundColor: backgroundColor ? backgroundColor : "white",
        borderRadius: borderRadius ? borderRadius : "8px",
        border: "solid 1px #DFE5EE",
      }}
      container>
      <Grid
        item
        lg={2}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <SearchIcon
          sx={{
            marginLeft: "5px",
            color: "gray",
            width: { sm: 20 },
            height: { sm: 20 },
          }}
        />
      </Grid>
      <Grid
        lg={10}
        sx={{
          display: "flex",
          alignItems: "center",
        }}>
        <TextField
          style={{ width: "160px" }}
          id="outlined-basic"
          InputProps={{ disableUnderline: true }}
          placeholder={placeHolder}
          onChange={onChagevalue}
          InputLabelProps={{
            style: { color: "red" },
          }}
        />
      </Grid>
    </Grid>
  );
}

export default SearchBar;
